module.exports = __webpack_public_path__ + "static/22-3d81b9141e43521e64b9cbb26c0658d0.png";